export enum TLD {
  SE = 'se',
  NU = 'nu',
  TEST = 'test',
}
